import React from 'react';
import { ClockIcon, UsersIcon, ArrowRightIcon, CheckIcon } from 'lucide-react';
import { CHECKOUT_URL, resumenEntrega } from '../data/oferta';
const SELLO_GARANTIA = 'https://cdn.magicpatterns.com/uploads/hbpxGwHg3asJvXHPziXpBp/Recursos_Graficos_Premium.jpg';
export function PrecioSection() {
  return <section id="inscripcion" aria-labelledby="precio-titulo" className="scroll-mt-4 bg-bone text-violet-deep" data-id="element-66" data-mp="hoi8vf52mlse">
      {/* Gancho de urgencia: primera cosa que se ve al llegar al precio */}
      <div className="bg-violet-deep" data-id="element-67" data-mp="qmu1fmphztnh">
        <div className="mx-auto flex max-w-5xl flex-col items-center justify-center gap-2 px-6 py-3.5 text-center sm:flex-row sm:gap-8 lg:px-8" data-id="element-68" data-mp="vn87x0bgavje">
          <p className="flex items-center gap-2 font-sans text-sm font-semibold text-gold" data-id="element-69" data-mp="10l9qlk4yssuc">
            <ClockIcon className="h-4 w-4 flex-none" aria-hidden="true" data-id="element-70" data-mp="2xfmnhsqivnwn" />
            La inscripción del próximo grupo cierra esta semana
          </p>
          <p className="flex items-center gap-2 font-sans text-sm font-light text-bone/75" data-id="element-71" data-mp="32firhrz7zfc7">
            <UsersIcon className="h-4 w-4 flex-none" aria-hidden="true" data-id="element-72" data-mp="fug69a7l1p3o" />
            Cupos limitados — el grupo se cierra al llegar a 12 personas
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-6 py-20 sm:py-24 lg:px-8" data-id="element-73" data-mp="62tn8rp06lqd">
        <div className="grid items-stretch gap-10 lg:grid-cols-[1.15fr_1fr] lg:gap-14" data-id="element-74" data-mp="14ib2ab8jz4z">
          {/* Precio + CTA principal */}
          <div className="flex flex-col items-center border-2 border-violet-deep bg-white px-7 py-10 text-center shadow-[10px_10px_0_0_rgba(45,27,78,0.12)] sm:px-10 sm:py-12" data-id="element-75" data-mp="yqfymm4h2uns">
            <p className="font-sans text-xs font-semibold uppercase tracking-[0.28em] text-gold-deep" data-id="element-76" data-mp="orqfkq0ub45y">
              Inscripción
            </p>

            <h2 id="precio-titulo" className="mt-5 font-serif text-3xl font-medium leading-tight text-violet-deep sm:text-4xl" data-id="element-77" data-mp="39jagwlsgqq4u">
              Mentoría Recupérate con Poder
            </h2>
            <p className="mt-2 font-sans text-xs font-medium uppercase tracking-[0.22em] text-violet-deep/50" data-id="element-78" data-mp="36yku8v6dk797">
              Programa completo de 5 semanas
            </p>

            <ul className="mt-8 w-full space-y-3 text-left" data-id="element-79" data-mp="2x0ol28wzzmdq">
              {resumenEntrega.map(item => <li key={item} className="flex gap-3" data-id="element-80" data-mp="31zhplbub431r">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-gold-deep" aria-hidden="true" data-id="element-81" data-mp="31xwv1m7zsk3w" />
                  <span className="font-sans text-sm font-light leading-snug text-violet-deep/80" data-id="element-82" data-mp="2szbdnue9bb4p">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div aria-hidden="true" className="mt-8 h-px w-16 bg-gold-deep/60" data-id="element-83" data-mp="2jabea9vuedpz" />

            <p className="mt-8 font-sans text-xs font-medium uppercase tracking-[0.22em] text-violet-deep/50" data-id="element-84" data-mp="25a0nf6uj8z4t">
              Tu inversión
            </p>
            <p className="mt-2 font-serif text-7xl font-semibold leading-none text-violet-deep sm:text-8xl" data-id="element-85" data-mp="1qmih641bnwga">
              $297
              <span className="ml-2 align-top font-sans text-xl font-medium tracking-wide sm:text-2xl" data-id="element-86" data-mp="1loqk6vltlk58">
                USD
              </span>
            </p>
            <p className="mt-3 font-sans text-sm font-medium tracking-wide text-violet-deep/70" data-id="element-87" data-mp="1uodhb57io3sh">
              Pago único · Acceso completo a las 5 semanas
            </p>

            <a href={CHECKOUT_URL} className="group mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-gold px-8 py-5 font-sans text-base font-bold tracking-wide text-violet-deep transition-colors duration-200 ease-out hover:bg-gold-deep hover:text-bone focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-deep focus-visible:ring-offset-2 focus-visible:ring-offset-white sm:text-lg" data-id="element-88" data-mp="29jjldmn1xsj6">
              Quiero inscribirme ahora
              <ArrowRightIcon className="h-5 w-5 flex-none transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-89" data-mp="2nevnif3jela4" />
            </a>
            <p className="mt-4 text-center font-sans text-xs font-light text-violet-deep/55" data-id="element-90" data-mp="3bee83sa4nlp5">
              Pago seguro procesado por Hotmart
            </p>
          </div>

          {/* Garantía con insignia */}
          <div className="flex flex-col items-center justify-center border border-gold-deep/40 bg-violet-deep px-8 py-10 text-center sm:px-10" data-id="element-91" data-mp="2ogb1jjz6oxg2">
            <div className="h-36 w-36 overflow-hidden rounded-full sm:h-40 sm:w-40" data-id="element-92" data-mp="2sio3dxat8b7k">
              <img src={SELLO_GARANTIA} alt="Insignia de garantía de 7 días" className="h-full w-full scale-[1.2] object-cover" loading="lazy" data-id="element-93" data-mp="2xgpvf7q7rkv6" />
            </div>

            <h3 className="mt-6 font-serif text-3xl font-medium text-gold-soft" data-id="element-94" data-mp="csuvnse3owyn">
              Garantía de 7 días
            </h3>
            <p className="mt-3 max-w-sm font-sans text-sm font-light leading-relaxed text-bone/80" data-id="element-95" data-mp="227mencg5qpt9">
              Si después de la primera semana sientes que esto no es para ti, te
              devuelvo tu inversión completa. Sin vueltas, sin preguntas
              incómodas.
            </p>
            <p className="mt-6 font-sans text-xs font-medium uppercase tracking-[0.22em] text-bone/45" data-id="element-96" data-mp="1nizqqmcgspqf">
              El riesgo lo asumo yo
            </p>
          </div>
        </div>
      </div>
    </section>;
}